<script lang="ts">
  import { fly } from 'svelte/transition';
  import { flip } from 'svelte/animate';
  import { toasts } from '$lib/state/toast.svelte';
</script>

<!--
  Top-center overlay banner. `fixed top-3` so it draws over content
  without shifting layout. `pointer-events-none` on the container so the
  page below stays interactive (only the toast bodies themselves get
  pointer events back); banner toasts are short-lived informational —
  users shouldn't need to click them.

  fly={{ y: -16 }} slides each toast down from above on mount and up on
  unmount. animate:flip smooths reorder when an earlier toast disappears
  and the rest slide up to fill its slot. Both keyed by t.id (already on
  the each block) so Svelte tracks identity correctly.
-->
<div
  class="fixed inset-x-0 top-3 z-50 flex flex-col items-center gap-2 pointer-events-none px-3"
  role="region"
  aria-label="Notifications"
>
  {#each toasts.list as t (t.id)}
    <div
      role={t.kind === 'error' ? 'alert' : 'status'}
      aria-live={t.kind === 'error' ? 'assertive' : 'polite'}
      class="pointer-events-auto px-4 py-2 rounded-md shadow-lg text-sm font-medium max-w-2xl text-center {t.kind ===
      'success'
        ? 'bg-green-600 text-white'
        : 'bg-red-600 text-white'}"
      in:fly={{ y: -16, duration: 180 }}
      out:fly={{ y: -16, duration: 150 }}
      animate:flip={{ duration: 200 }}
    >
      {t.message}
    </div>
  {/each}
</div>
